import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { crossIcon, MinusIconEmpty } from '../../Assets/svg';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import BASEURL from '../../Config/global';
import { getPlaylistConfig } from '../../Util/helpers';
import { addPlaylistTracks, removeAllTracks } from '../../Store/Slices/PlayerSlice';
import { useTranslation } from 'react-i18next';

const EditPlaylistModal = ({ isOpen, onClose, onSuccess }) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { selectedId, selectedName, selectedItem, shareSystemCreatedPlaylist } = useSelector((state) => state.player);
    const config = useSelector((state) => state.player.config);

    const [state, setState] = useState({
        id: null,
        value: "",
        data: [],
        error: false,
        errorMsg: "",
    });

    useEffect(() => {
        if (isOpen) {
            setState({
                id: selectedId,
                value: selectedName,
                data: selectedItem,
                error: false,
                errorMsg: "",
            });
        }
    }, [selectedId, selectedName, selectedItem, isOpen]);


    const handleChange = (e) => {
        setState((prev) => ({
            ...prev,
            value: e.target.value,
            error: false,
            errorMsg: "",
        }));
    };

    const handleSave = async () => {
        const trimmedValue = state.value.trim();

        if (!trimmedValue) {
            setState((prev) => ({
                ...prev,
                error: true,
                errorMsg: t("playlists.enterPlaylistName"),
            }));
            return;
        }

        try {

            const payload = {
                name: trimmedValue,
                tracks: getPlaylistConfig(state.data),
                ...(shareSystemCreatedPlaylist && {
                    repeat: false,
                    shuffle: false,
                    playlist_type: 'music_lullaby',
                }),
            }

            let response;

            if (shareSystemCreatedPlaylist) {
                response = await axios.post(`${BASEURL}/api/user/playlists/`, payload);
            } else {
                response = await axios.patch(`${BASEURL}/api/user/playlists/${selectedId}/`, payload);
            }

            if (!response.data.error) {
                if (selectedId === config.id) {
                    dispatch(removeAllTracks());
                }
                onSuccess('updated-playlist');
                setState({
                    id: null,
                    value: "",
                    data: [],
                    error: false,
                    errorMsg: "",
                });
            } else {
                setState({ value: "", error: true, errorMsg: t("playlists.unexpectedError") });
            }
        } catch (error) {
            setState({ value: "", error: true, errorMsg: t("playlists.unexpectedError") });
        }
    };

    const handleRemoveItem = (item) => {
        const newList = state.data.filter(t => t.id !== item.id);
        setState((prev) => ({ ...prev, data: newList })); // update local state
    };


    return (
        <div>
            <Modal show={isOpen} centered className="custom-modal" backdrop="static">
                <Modal.Body>
                    <div className="text-end">
                        <button className="closeButton notButton ms-auto" onClick={() => onClose('edit-playlist')}>
                            <img src={crossIcon} alt="Close" />
                        </button>
                    </div>
                    <div className="customModalContent">
                        <h2 className="fs-5 mb-4 pb-2 fw-bold text-center">{t("playlists.editPlaylist")}</h2>
                        <div className='mb-2'>
                            <input
                                type="text"
                                value={state.value}
                                onChange={handleChange}
                                className="searchBar w-100"
                            />
                            {state.error && (
                                <small
                                    className="text-danger d-inline-block mt-2 text-center"
                                    style={{ lineHeight: 1.4 }}
                                >
                                    {state.errorMsg}
                                </small>
                            )}
                        </div>

                        {state.data.map((item, index) => (
                            <div className="mixerSoundDetail px-3 py-2">
                                <div className="mixerSoundThumbnailWrapper flex-shrink-0">
                                    <div className="mixerAudioThumbnail">
                                        <img src={item?.image} alt="Thumbnail" />
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <p className={`mixerAudioTitle`}>{item?.title ?? item?.name}</p>
                                </div>
                                <div className="flex-shrink-0">
                                    <button className="btn p-1 d-flex" onClick={() => handleRemoveItem?.(item)}>
                                        <img src={MinusIconEmpty} width={20} alt="Cross Icon" />
                                    </button>
                                </div>
                            </div>
                        ))}

                        <div className="mt-2 pt-2 d-flex gap-3 justify-content-center">
                            <button
                                style={{ backgroundColor: "#ffffff1f", fontSize: '14px' }}
                                className="px-5 py-2 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0"
                                onClick={handleSave}
                            >
                                <span>{t("playlists.update")}</span>
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default EditPlaylistModal
